import React, { useEffect, useState } from 'react';
import {
  NEWS_IMAGE_FALLBACK,
  resolveNewsImage,
} from '../utils/newsImage';
import '../styles/NewsImage.css';

const NewsImage = ({
  news,
  src,
  alt = '',
  className = '',
  width,
  height,
  loading = 'lazy',
  fetchPriority,
  fallbackSrc = NEWS_IMAGE_FALLBACK,
  sizes,
  srcSet,
  ...imageProps
}) => {
  const resolvedSource = resolveNewsImage(news || src, fallbackSrc);
  const [currentSource, setCurrentSource] = useState(resolvedSource);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setCurrentSource(resolvedSource);
    setLoaded(false);
  }, [resolvedSource]);

  const handleError = () => {
    setLoaded(false);
    if (currentSource !== fallbackSrc) {
      setCurrentSource(fallbackSrc);
    }
  };

  return (
    <img
      {...imageProps}
      src={currentSource}
      alt={alt}
      className={`news-image-component ${loaded ? 'is-loaded' : ''} ${className}`.trim()}
      width={width}
      height={height}
      loading={loading}
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      sizes={sizes}
      srcSet={srcSet}
      onLoad={(event) => {
        setLoaded(true);
        imageProps.onLoad?.(event);
      }}
      onError={handleError}
    />
  );
};

export default NewsImage;
